//LinkedIn Learning: Learning Full-Stack Javascript Development: MongoDB, Node, and React

import React, {Component} from 'react';
import {Jumbotron, Button, Table, ButtonToolbar, FormGroup, FormLabel, FormControl, Container, Row, Col, Modal, Tab, Tabs } from 'react-bootstrap';
//below is needed to use react-bootstrap with react-router
import { LinkContainer } from 'react-router-bootstrap';


class Register extends Component{
  state = {
    query: '',
    eventMarketName: '',
    eventFirstName: '',
    eventLastName: '',
    eventEMail: '',
    eventUserType: '',
    eventUserOrganization: '',

    show: false,
    selectedUser: '',
  }

  updateQuery = (query) => {
    if(query !== "" || query !== undefined){
      this.setState({
        query: query.target.value.substr(0,40)
      })

    }
  }

  handleShow = (user) => {
    this.setState(
      {
        show: true,
        selectedUser: user,
      });
  }

  handleClose = () => {
    this.setState({show: false});
  }

  handleCloseAndDelete = (userID) => {

    this.setState({show: false});
    this.props.deleteUser(userID)
  }

  handleFirstNameChange = (event) => {

    this.setState({eventFirstName: event.target.value})
    console.log('onType', this.state.eventFirstName)
  }

  handleLastNameChange = (event) => {

    this.setState({eventLastName: event.target.value})
    console.log('onType', this.state.eventLastName)
  }

  handleEMailChange = (event) => {

    this.setState({eventEMail: event.target.value})
    console.log('onType', this.state.eventEMail)
  }

  handlePasswordChange = (event) => {

    this.setState({eventPassword: event.target.value})
    console.log('onType', this.state.eventPassword)
  }

  handleUserTypeChange = (event) => {

    this.setState({eventUserType: event.target.value})
    console.log('onType', this.state.eventUserType)
  }

  handleUserOrganizationChange = (event) => {

    this.setState({eventUserOrganization: event.target.value})
    console.log('onType', this.state.eventUserOrganization)
  }

/*
  onSubmitHandle(event) {
  event.preventDefault();
  this.setState({

  });
  console.log('tsting')
  event.target.item.value = '';
}*/


  render(){
    console.log('Props', this.props)


    return(
      <div className="viewPage">

        <Container>
        <br/>
        <h4>Register here</h4>
        <div>
        <form >
          <FormGroup  controlId="formControlsTextarea">

              <FormLabel>First Name</FormLabel>
              <FormControl onChange={this.handleFirstNameChange}  placeholder="Enter First Name" style={{ height: 30 }}/>
              <FormLabel>Last Name</FormLabel>
              <FormControl onChange={this.handleLastNameChange}  placeholder="Enter Last Name" style={{ height: 30 }}/>
              <FormLabel>E-Mail</FormLabel>
              <FormControl onChange={this.handleEMailChange}  placeholder="Enter E-Mail" style={{ height: 30 }}/>
              <FormLabel>Password</FormLabel>
              <FormControl onChange={this.handlePasswordChange}  placeholder="Enter Password" style={{ height: 30 }}/>

          </FormGroup>
          <Button onClick={() => this.props.registerUser(this.state.eventFirstName, this.state.eventLastName, this.state.eventEMail, this.state.eventPassword)} bsstyle="success">Register New User</Button>
        </form>
        <br/>
        <br/>
        </div>
          

            </Container>
            <br/>
            <br/>

      </div>
    )
  }
}
export default Register;
